export default "__VITE_ASSET__DAOf56AD__"